import dayjs from "dayjs";
import {useBaseComponent} from "../base/base-component";
import server from "../server";
import {EventData} from "../domains/models/event";
import {useEffect} from "react";


interface IState {

    data: EventData,
    internal: {
        isLoading: boolean;
    }
}

interface Props {
    startDate?: string;
    endDate?: string;
    activeCategory?: string;
}

interface EventRequest {
    'start-date': string;
    'end-date': string;
    'include-birthdays'?: boolean;
    'include-events'?: boolean;
    'include-trainings'?: boolean;
    'include-work-anniversaries'?: boolean;
}


const useEventData = ({startDate, endDate, activeCategory}: Props = {}) => {

    const {state, updateState} = useBaseComponent<Props, IState>({startDate, endDate}, {
        initialState: () => ({
            data: {
                birthdays: [],
                workAnniversaries: [],
                events: [],
                trainingEvents: []
            },
            internal: {
                isLoading: false
            }

        }),
    });

    useEffect(() => {
        fetchEvents();
    }, [startDate, endDate, activeCategory])


    async function fetchEvents() {
        try {
            updateState('internal.isLoading', true);
            let finalStart = startDate;
            let finalEnd = endDate;

            // If no range provided → default to current month
            if (!finalStart || !finalEnd) {
                const today = dayjs();
                finalStart = today.startOf('month').format('YYYY-MM-DD');
                finalEnd = today.endOf('month').format('YYYY-MM-DD');
            }

            let payload: EventRequest = {
                'start-date': finalStart,
                'end-date': finalEnd
            }

            switch (activeCategory) {
                case "Trainings":
                    payload = {...payload, 'include-trainings': true}
                    break;
                case "Birthdays":
                    payload = {...payload, 'include-birthdays': true}
                    break;
                case "Events":
                    payload = {...payload, 'include-events': true}
                    break;
                case "Work Anniversary":
                    payload = {...payload, 'include-work-anniversaries': true}
                    break;
            }


            const response: EventData = await server.event.list(payload);


            if (!response) {
                updateState('internal.isLoading', false);
                return;
            }

            // Update state
            updateState('data', response);

        } catch (error) {
            console.error("Error fetching events:", error);
        } finally {
            updateState('internal.isLoading', false);

        }
    }

    return {
        data: state.data,
        refetch: fetchEvents,
        isLoading: state.internal.isLoading,
    };
};

export default useEventData;
